// extensions/StreamingMark.ts
import { Mark, mergeAttributes } from "@tiptap/core"

export const StreamingMark = Mark.create({
  name: "streaming",

  parseHTML() {
    return [{ tag: 'span[data-streaming]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, {
      'data-streaming': 'true',
      class: 'streaming-text'
    }), 0]
  },
})
